import { useEffect } from 'react'

import { Card, Col, Row, Typography, Button, Table, Form, Input, Radio, Space, Divider, message, Popover } from 'antd';
import { InfoCircleOutlined, PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import TableColumns from "./TableColumns";

import useIdioma from "./HookIdioma";
import { useEgresadoContext } from '../../../context/EgresadoProvident';

import "./TableStyles.css";

const { Title } = Typography


const Idioma = ({ id_card }) => {

    const { alumno } = useEgresadoContext();

    const {
        idiomas,
        crearIdioma,
        editingIdioma,
        catalogos,
        loading,
        onNuevoIdioma,
        onSave,
        editarIdioma,
        onCancel,
        deleteIdIdiomaMe
    } = useIdioma(alumno?.idiomas ?? []);

    return (
        <Card id={id_card}>
            {
                (!crearIdioma && Object.keys(editingIdioma).length === 0) ? <IdiomaTable
                    loading={loading}
                    onNuevoIdioma={onNuevoIdioma}
                    idiomas={idiomas}
                    editarIdioma={editarIdioma}
                    deleteIdIdiomaMe={deleteIdIdiomaMe}
                /> : <IdiomaForm
                    idiomas={idiomas}
                    catalogos={catalogos}
                    editingIdioma={editingIdioma}
                    loading={loading}
                    onCancel={onCancel}
                    onSave={onSave}
                />
            }
        </Card>
    )
}

const IdiomaTable = (props) => {
    const { loading, onNuevoIdioma, idiomas, editarIdioma, deleteIdIdiomaMe } = props
    return (
        <>
            <Row justify="space-between" align="middle">
                <TitleSeccion />
                <Col>
                    <Button
                        loading={loading}
                        type="text"
                        style={{ color: '#7c0433' }}
                        icon={<PlusOutlined />}
                        onClick={() => onNuevoIdioma()}
                    >
                        Agregar idioma / lengua indígena
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Table
                        rowClassName="editable-row"
                        rowKey={'id_idioma'}
                        className="my-custom-table"
                        size="small"
                        bordered
                        loading={loading}
                        columns={TableColumns(loading, editarIdioma, deleteIdIdiomaMe)}
                        dataSource={idiomas}
                        pagination={{ position: ['bottomRight'], pageSize: 5 }}

                    />
                </Col>
            </Row>
        </>
    )
}

const IdiomaForm = (props) => {
    const { idiomas, catalogos, loading, editingIdioma, onCancel, onSave } = props

    const idiomasExtranjeros = [
        "inglés", "mandarín", "francés", "árabe", "portugués", "ruso", "japonés", "alemán", "coreano"
    ];

    const lenguasIndigenas = [
        "náhuatl", "maya", "mixteco", "zapoteco", "otomi", "totonaca", "mazateco", "tlaxcalteca", "p'urhépecha",
        "huasteco", "chatino", "tzetzal", "tarahumara", "cuicateco", "mixe", "chocholteco", "chinanteco", "huichol",
        "ayotl", "totonacapan"
    ];


    useEffect(() => {
        if (editingIdioma) {
            form.setFieldsValue(editingIdioma);
        }
    }, [editingIdioma])


    const opcionRadioButton = [
        { value: true, label: 'Si' },
        { value: false, label: 'No' },
    ];

    const [form] = Form.useForm();

    const handleOk = async () => {
        await form.validateFields();
        const formData = form.getFieldsValue();

        if (Object.keys(editingIdioma).length > 0) {
            formData.id_idioma = editingIdioma.id_idioma // Si estamos editando, añadimos el id del idioma
        }

        await onSave(formData);
    }

    const validarIdiomaUnico = (rule, value) => {
        const existe = idiomas.some((idioma) => idioma.idioma?.toLowerCase().trim() === value?.toLowerCase().trim() && idioma?.id_idioma !== editingIdioma.id_idioma);
        if (existe) {
            return Promise.reject('Este idioma ya está registrado');
        }
        return Promise.resolve();
    };


    const handleIdiomaChange = (value) => {
        const normalizedValue = value.trim().toLowerCase(); // Normalizar el valor ingresado
        form.setFieldsValue({ tipo_idioma: null });
        if (normalizedValue === "español") {
            form.setFieldsValue({ tipo_idioma: "Idioma Oficial" });
        }
        else if (idiomasExtranjeros.includes(normalizedValue)) {
            form.setFieldsValue({ tipo_idioma: "Idioma Extranjero" });
        }
        else if (lenguasIndigenas.includes(normalizedValue)) {
            form.setFieldsValue({ tipo_idioma: "Lengua indígena" });
        }
    };

    return (
        <>
            <TitleSeccion />
            <Row>
                <Form
                    form={form}
                    onFinish={handleOk}
                    onFinishFailed={() => { message.error('Por favor complete todos los campos') }}
                    layout='vertical'
                >
                    <Row gutter={[16, 16]}>
                        <Divider orientation="center">Idioma / lengua indígena que hablas o comprendes</Divider>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="idioma"
                                label="Idioma / lengua indígena"
                                rules={[{ required: true, min: 3, max: 50, whitespace: true }, { validator: validarIdiomaUnico }]}

                            >
                                <Input
                                    placeholder="Idioma / lengua indígena ej: Inglés, Español, Náhuatl, Maya, etc."
                                    onChange={(e) => handleIdiomaChange(e.target.value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="lengua_materna"
                                label="¿Es tu idioma / lengua materna?"
                                rules={[{ required: true }]}
                            >
                                <Radio.Group options={opcionRadioButton} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="tipo_idioma"
                                label="Clasificación"
                                rules={[{ required: true }]}
                            >
                                <Radio.Group options={catalogos.tipo_idioma || []} />
                            </Form.Item>
                        </Col>

                        <Col span={13}>
                            <Form.Item
                                name="certificacion"
                                label="¿Cuentas con una certificación oficial?"
                                rules={[{ required: true }]}
                            >
                                <Radio.Group options={opcionRadioButton} onChange={(e) => form.setFieldsValue({ nombre_certificacion: null })} />
                            </Form.Item>
                        </Col>
                        <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => prevValues.certificacion !== currentValues.certificacion}
                        >
                            {({ getFieldValue }) => {
                                return getFieldValue('certificacion') === true ? (
                                    <Col span={9}>
                                        <Form.Item
                                            name="nombre_certificacion"
                                            label="Nombre de la certificación oficial"
                                            rules={[{ required: true, min: 3, max: 50, whitespace: true }]}
                                        >
                                            <Input placeholder={"Ingresa el nombre de la certificación"} />
                                        </Form.Item>
                                    </Col>
                                ) : null

                            }}
                        </Form.Item>
                        <Divider orientation="center">Nivel de dominio </Divider>
                        <Col span={24}>
                            <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) => prevValues.tipo_idioma !== currentValues.tipo_idioma}
                            >
                                {({ getFieldValue }) => {
                                    return getFieldValue('tipo_idioma') === "Idioma Extranjero" ? (
                                        <Col span={24}>
                                            <Form.Item
                                                name="nivel_mcer"
                                                label="Nivel según el MCER"
                                                rules={[{ required: true }]}
                                                tooltip="Clasificación internacional de niveles de idioma: A1 y A2 (básico), B1 y B2 (intermedio), C1 y C2 (avanzado)."
                                            >
                                                <Radio.Group options={catalogos?.tipo_MCER || []} />
                                            </Form.Item>
                                        </Col>
                                    ) : (
                                        <Col span={24}>
                                            <Form.Item
                                                name="nivel_dominio"
                                                label="Nivel de dominio"
                                                rules={[{ required: true }]}
                                            >
                                                <Radio.Group options={catalogos?.fluidez_idioma || []} />
                                            </Form.Item>
                                        </Col>
                                    )
                                }}
                            </Form.Item>
                        </Col>
                        <Divider orientation="center">Nivel de exposición al idioma</Divider>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="exposicion_familiar"
                                label="¿Tu familia lo habla habitualmente?"
                                rules={[{ required: true }]}
                            >
                                <Radio.Group options={opcionRadioButton} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="uso_diario"
                                label="¿Lo usas en tu vida diaria?"
                                rules={[{ required: true }]}
                            >
                                <Radio.Group options={opcionRadioButton} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="formacion_academica"
                                label="¿Has recibido formación académica?"
                                rules={[{ required: true }]}
                            >
                                <Radio.Group options={opcionRadioButton} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="contexto_uso"
                                label="Describe los contextos en los que utilizas"
                                rules={[{ min: 3, max: 500, whitespace: true }]}
                            >
                                <Input.TextArea placeholder="Describe los entornos en los que utilizas" />
                            </Form.Item>
                        </Col>


                    </Row>
                    <Row justify="end">
                        <Space >
                            <Button
                                loading={loading}
                                type="primary"
                                htmlType="submit"
                            >
                                {editingIdioma ? "Guardar cambios" : "Agregar"}
                            </Button>
                            <Button
                                loading={loading}
                                onClick={() => {
                                    onCancel();
                                    form.resetFields();
                                }}>
                                Cancelar
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Row>
        </>
    )
}


const TitleSeccion = () => {
    return <Col>
        <Popover
            styles={{ root: { width: 250 } }}
            title="Idioma / lengua indígena"
            content={
                <div style={{ textAlign: 'justify' }}>
                    Registra cualquier idioma extranjero o lengua indígena que puedas hablar, escribir o comprender. No es necesario contar con certificación.
                </div>
            }
            placement="right" icon={<InfoCircleOutlined />}>

            <Title level={5} strong>Idioma / lengua indígena <QuestionCircleOutlined /></Title>
        </Popover>
    </Col>
}

export default Idioma;